/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S7_Body_PreInputs */

const tr_servis_s7_body_pre = /** @type {(inputs: Servis_S7_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı verilerinin işlenmesinde kullanılan alt yükleniciler `)
};

const en_servis_s7_body_pre = /** @type {(inputs: Servis_S7_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sub-processors used in the processing of User data are listed in section 4 of the `)
};

const de_servis_s7_body_pre = /** @type {(inputs: Servis_S7_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die bei der Verarbeitung von Nutzerdaten eingesetzten Unterauftragsverarbeiter sind in Abschnitt 4 der `)
};

const ru_servis_s7_body_pre = /** @type {(inputs: Servis_S7_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субподрядчики, используемые при обработке данных Пользователя, перечислены в разделе 4 документа `)
};

/**
* | output |
* | --- |
* | "The sub-processors used in the processing of User data are listed in section 4 of the" |
*
* @param {Servis_S7_Body_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s7_body_pre = /** @type {((inputs?: Servis_S7_Body_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S7_Body_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s7_body_pre(inputs)
	if (locale === "de") return de_servis_s7_body_pre(inputs)
	if (locale === "ru") return ru_servis_s7_body_pre(inputs)
	return tr_servis_s7_body_pre(inputs)
});